<p-confirmDialog class="order_confirm_dialog"></p-confirmDialog>
<div class="h-100">
  <div class="back-to-tables-btn-container">
    <a (click)="returnStateToOrderTable()" class="back-to-tables-btn">
      <i class="pi pi-arrow-left"></i></a>
  </div>
<div class="table_order_container">
<div class="table_items_display w-100">
  <div class="items_list_edit_header d-flex justify-content-between">
    <span class="d-flex align-items-center"><ng-container *ngIf="orderBillNumber">{{'ORDER.ORDER_NUMBER' | translate | uppercase}}  #{{orderBillNumber}}</ng-container></span>
    <div>
      <ng-container *ngIf="!editMode">
        <button class="edit_order_btn mx-2" (click)="changeEditMode()">{{'EDIT' | translate}}</button>
        <button class="cancel_order_btn" (click)="cancelOrder()">{{'DELETE' | translate}}</button>
      </ng-container>
      <ng-container *ngIf="editMode">
        <button class="edit_order_btn mx-2" (click)="changeEditMode()">{{'SAVE' | translate}}</button>
        <button class="cancel_order_btn" (click)="cancelEdit()">{{'CANCEL' | translate}}</button>
      </ng-container>
    </div>
  </div>
  <div class="display_order_items_table_content_wrapper flex-grow-1">
    <div class="list_item d-flex flex-row justify-content-between" *ngFor="let item of order.items">
        <span>{{item.venueMenuItemName}}</span>
        <span *ngIf="!editMode">{{item.quantity}}</span>
        <ng-container *ngIf="editMode">
          <div class="d-flex justify-content-center">
            <button class="decrease_quantity_btn" [disabled]="item.quantity <= 0" (click)="decreaseQuantity(item)">-</button>
            <div class="input_quantity">{{item.quantity}}</div>
            <button class="increase_quantity_btn" (click)="increaseQuantity(item)">+</button>
          </div>
        </ng-container>
    </div>
  </div>
  <div class="items_list_footer d-flex flex-row justify-content-end pe-4">
    {{'ORDER_DETAILS.TOTAL' | translate}} {{order.price | customCurrencyPipe: currency.shortName :'1.0-2'}}
  </div>
  <div class="footer_wrapper">
    <div class="d-flex flex-row justify-content-between ps-4 pe-4">
      <a class="add_note_link" (click)="addNote()">
        {{'ORDER.ADD_NOTE' | translate | uppercase}} <i class="pi pi-book ms-2"></i>
      </a>
      <span class="display_total">
        {{'ORDER_DETAILS.TOTAL' | translate}} {{order.priceWithTax | customCurrencyPipe: currency.shortName :'1.0-2'}}</span>
    </div>
    <div class="w-100 d-flex justify-content-end mt-2">
      <button class="save_order_btn" [disabled]="disabledOrderCreation()" (click)="createOrder()">{{'ORDER.CREATE_ORDER' | translate}}</button>
    </div>
  </div>
</div>
</div>
</div>
